import core from '@gin-betting/core';

import moduleLocator from 'moduleLocator';

const { measureTime } = core.utils;
const { withAsyncLoad } = core.hocs;

const BETS_HISTORY_LOADING_DELAY = 0;

export const loadBetsHistoryModule = () =>
    import(/* webpackChunkName: "bets-history-module" */ './index').then(
        betsHistoryModule => {
            measureTime('betsHistoryModuleLoaded');

            moduleLocator.set('betsHistory', betsHistoryModule);

            return betsHistoryModule;
        }
    );

export const AsyncBetsHistoryContainer = withAsyncLoad({
    loader: loadBetsHistoryModule,
    delayLoading: BETS_HISTORY_LOADING_DELAY,
    loading: () => null,
    componentToRender: 'BetsHistory',
});
